<!--
    描述：用户组角色管理
    日期：2021/04/27
    作者：zwh
-->
<template>
	<div class="h100">
		<w-split v-model="splitValueL">
			<div class="h100"
				 slot="left">
				<roleTreeTable ref="roleTreeTable"
							   @row-click="roleRowClick"></roleTreeTable>
			</div>
			<div class="h100"
				 slot="right">
					<el-col :span="12"
							class="h100"
							style="border-right:1px solid #eee">
						<menuTree ref="menuTree"
								  @row-click="menuRowClick"
								  :currentRole="currentRole"></menuTree>
					</el-col>
					<el-col :span="12"
							class="h100"
							style="border-right:1px solid #eee">
						<btnTree ref="btnTree"
								 :currentRole="currentRole"></btnTree>
					</el-col>
			</div>
		</w-split>
	</div>
</template>
<script>
import wSplit from '@/components/split/split'
import wSplitRight from '@/components/split/split'
import groupTreeTable from './components/group_tree_table'
import roleTreeTable from './components/role_tree_table'
import menuTree from './components/menu_tree'
import btnTree from './components/btn_tree'
import deptTreeTable from './components/dept_tree_table'
export default {
	name: '',
	components: {
		wSplit,
		wSplitRight,
		groupTreeTable,
		roleTreeTable,
		menuTree,
		btnTree,
		deptTreeTable,
	},
	data() {
		return {
			splitValueL: 0.45,
			clickGroupObj : '',     //用户组点击对象
			clickRoleObj: '', //角色点击对象
			clickMenuObj: '', //菜单点击对象
			currentRole: '',
		}
	},
	methods: {
		//用户组行点击
		groupRowClick(e) {
			if (this.clickGroupObj.id == e.id) return

			this.clickGroupObj = e
			//角色行点击
			this.roleRowClick('')
			//菜单行点击
			this.menuRowClick('')

			let obj = { groupId: e.id, groupName: e.sname }
			this.$refs.roleTreeTable.init(obj)
		},

		//角色行点击
		roleRowClick(e) {
			if (e != '' && this.clickRoleObj.id == e.id) return

			this.clickRoleObj = e
			this.menuRowClick('')
			let obj = { groupId: '', roleId: '', roleType: '', limitId: '' }
			//点击组信息
			if (this.clickRoleObj != '') obj.groupId = this.clickRoleObj.id
			//点击角色信息
			if (this.clickRoleObj != '') {
				obj.roleId = e.id
				obj.roleType = e.roleType
				obj.limitId = e.limitId

				// 公共角色还是 私有角色
				this.currentRole = e.roleType
			}

			//菜单信息
			this.$refs.menuTree.getMenuTreeInfoPlus(obj)
		},

		//菜单行点击
		menuRowClick(e) {
			this.clickMenuObj = e
			let obj = { groupId: '', menuId: '', roleId: '', roleType: '' }
			//点击组信息
			if (this.clickRoleObj != '') obj.groupId = this.clickRoleObj.id
			//点击角色信息
			if (this.clickRoleObj != '') {
				obj.roleId = this.clickRoleObj.id
				obj.roleType = this.clickRoleObj.roleType
			}
			//点击按钮信息
			if (this.clickMenuObj != '') obj.menuId = e.id

			//查询按钮列表
			this.$refs.btnTree.init(obj)
		},
	},
}
</script>